var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"select_box",class:{
    'select_box--out_of_stock': _vm.isOutOfStock
  },on:{"click":_vm.selectRadioBtn}},[_c('p',{class:{
      select_box_label: !_vm.isSelected,
      'select_box_label--selected': _vm.isSelected
    }},[_c('span',{staticClass:"select_box_span"},[_vm._v("\n      "+_vm._s(_vm.label)+"\n    ")])]),_vm._v(" "),(_vm.isOutOfStock)?_c('p',{staticClass:"select_box--out_of_stock--text"},[_vm._v("\n    入荷待ち\n  ")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }